import Vue from "vue";
import Vuex from "vuex";
import axios from "../axios";

import mock from "@/mock";
import util from '../util'
Vue.use(Vuex);

var dateFormat = util.dateFormat
var indexQuery = util.indexQuery
var findCaseByName = util.findCaseByName
var deepClone = util.deepClone
var url =
  process.env.NODE_ENV == "production" ? window.global.reqUrl : mock.reqUrl;

url = '';

var $search_client =
  process.env.NODE_ENV == "production"
    ? window.global.search_client
    : mock.search_client;
var $graph_client =
  process.env.NODE_ENV == "production"
    ? window.global.graph_client
    : mock.graph_client;
const store = new Vuex.Store({
  state: {
    editMode: false,
    gridView: true,
    allCases: [],
    allItems: [],
    beSelected: [],
    tags: [],
    tagBeSelected: [],
    keyWord: "",
    requestPending: false
  },
  mutations: {
    pendingToggle(state) {
      state.requestPending = !state.requestPending;
    },
    editModeToggle(state) {
      state.editMode = !state.editMode;
    },
    gridViewToggle(state) {
      state.gridView = !state.gridView;
    },
    select(state, oid) {
      let index = state.beSelected.indexOf(oid);
      if (index == -1) {
        state.beSelected.push(oid);
      } else {
        state.beSelected.splice(index, 1);
      }
    },
    clearSelect(state) {
      state.beSelected = [];
    },
    tagSelect(state, index) {
      let tag = state.tags[index];
      let tagIndex = state.tagBeSelected.indexOf(tag);
      if (tagIndex == -1) {
        state.tagBeSelected.push(tag);
      } else {
        state.tagBeSelected.splice(tagIndex, 1);
      }
    },
    clearTagSelect(state) {
      state.tagBeSelected = [];
    },
    searchByKeyword(state, val) {
      state.keyWord = val;
    },
    clearKeyword(state) {
      state.keyWord = "";
    },
    getCases(state, cases) {
      state.allCases = cases;
    },
    getTags(state, tag) {
      state.tags = tag;
    },
    getItems(state, items) {
      state.allItems = items;
    },
    createCase(state, new_case) {
      state.allCases.unshift(new_case);
    },
    caseRename(state, data) {
      let index = indexQuery(state.allCases, data['oid'])
      let new_name = data.name;
      state.allCases[index]["caseName"] = new_name;
    },
    caseDelete(state, index) {
      state.allCases.splice(index, 1);
    },
    moveItem(state, data) {
      let case_index = indexQuery(state.allCases, data["target_case"]);
      let item_index = indexQuery(state.allItems, data["item_oid"]);

      let item = state.allItems[item_index];
      let type = item["type"];

      state.allCases[case_index][type]++;
      state.allItems[item_index]["case_belong_id"] = data["target_case"];
      let pre_case_index = data["pre_case_index"];
      if (pre_case_index) {
        state.allCases[pre_case_index][type]--;
      }
    },
    itemMoveOut(state, data) {
      let case_index = indexQuery(state.allCases, data.case_oid);
      let item_index = indexQuery(state.allItems, data.item_oid);
      state.allCases[case_index][data.type]--;
      state.allItems[item_index]["case_belong_id"] = null;
    },
    deleteItem(state, index) {
      let case_in = state.allItems[index]["case_belong_id"] || null;
      let type = state.allItems[index]["type"];
      if (case_in) {
        let case_index = indexQuery(state.allCases, case_in);
        state.allCases[case_index][type]--;
      }
      state.allItems.splice(index, 1);
    },
    // handle data from get_workspace response
    dataHandle(state, data) {
      let cases = data.cases;
      let new_cases = [];
      let items = data.files;
      let new_items = [];
      let doc_count = {};
      let graph_count = {};

      for (let i in items) {
        let content = items[i].content;
        let caseId = items[i]["case_belong_id"] || null;
        let new_item = {};
        let fileId = items[i]["object_id"].slice(1);
        if (items[i].genre == "doc") {
          new_item["case_belong_id"] = items[i]["case_belong_id"] || null;
          new_item["tags"] = content.tags || [];
          new_item["notes"] = [];
          new_item["lastSaved"] = dateFormat(items[i]["last_modified"]);
          new_item["type"] = "doc";
          new_item["companyName_en"] = content["company_name"] || "";
          new_item["companyName_cn"] = content["company_name_ch"] || "";
          new_item["stockCode"] = content["stock_code"].join("");
          new_item["content_id"] = items[i].content_id;
          new_item["content_lib"] = items[i].content_lib;
          new_item["o_id"] = items[i].object_id;
          new_item["stored_path"] = items[i]["stored_path"];
          new_item["name"] = content["title"];
          new_item["img"] = `${url}/wp.doc_thumbnail/?content_id=${
            items[i].content_id
            }&lib=${items[i].content_lib}&stored_path=${
            items[i].stored_path ? items[i].stored_path : ""
            }`;
          new_item[
            "url"
          ] = `${$search_client}/document/${items[i].content_lib}/${items[i].content_id}/`;
          if (content.notes) {
            let custom, fromDoc;
            if ((custom = content.custom)) {
              if (custom.content && custom.content.trim().length) {
                new_item.notes.push(custom.content);
              }
            }
            if ((fromDoc = content.notes.fromDoc)) {
              for (var docComment in fromDoc) {
                if (fromDoc.hasOwnProperty(docComment)) {
                  new_item.notes.push(fromDoc[docComment].content);
                }
              }
            }
          }
        } else {
          new_item["case_belong_id"] = items[i]["case_belong_id"] || null;
          new_item["type"] = "graph";
          new_item["o_id"] = items[i]["object_id"];
          new_item["content_id"] = items[i]["content_id"];
          new_item["name"] = content.graphviz_title;
          new_item["dataSource"] = content["data_source"];
          new_item["lastSaved"] = dateFormat(items[i]["last_modified"]);
          new_item["img"] = `${url}/wp.gv_thumbnail/?vf_id=${fileId}`;
          new_item["url"] = `${$graph_client}?vid=${btoa(fileId)}&ds=${
            content["data_source"]
            }`;
        }

        new_items.push(new_item);

        if (caseId) {
          let count = items[i].genre == "gv" ? graph_count : doc_count;
          if (!count[caseId]) {
            count[caseId] = 1;
          } else {
            count[caseId]++;
          }
        }
      }

      for (let c in cases) {
        let cur_case = cases[c];
        let new_case = {};
        let oid = cur_case["object_id"];
        new_case["o_id"] = oid;
        new_case["caseName"] = cur_case["title"];
        new_case["lastSaved"] = dateFormat(cur_case.last_modified);
        new_case["doc"] = doc_count[oid] || 0;
        new_case["graph"] = graph_count[oid] || 0;
        new_cases.push(new_case);
      }
      this.commit("getTags", data.tags);
      this.commit("getCases", new_cases);
      this.commit("getItems", new_items);
    }
  },
  actions: {
    /**
     * update workspace
     * @param {*} context
     * @param {Object} data
     */
    update(context, data) {
      return axios({
        method: "post",
        url: `${url}/wp.update_workspace/`,
        data: data
      });
    },
    /**
     * get workspace
     */
    getWorkSpace({ commit }) {
      return axios({
        method: "post",
        url: `${url}/wp.get_workspace/`
      }).then(res => {
        let data = res.data;
        commit("dataHandle", data);
      });
    },
    /**
     * create case
     * @param {Object} _data -{data:caseName,timestamp:timestamp}
     */
    async createCase({ dispatch, commit, state }, _data) {
      // set requestPending to true
      commit("pendingToggle");

      let new_item = {};
      let name = _data.data;
      let timestamp = _data.timestamp;
      // a flag determine to return reject or resolve
      let ifError = false;
      // set attribute of the case will be created
      new_item["doc"] = 0;
      new_item["graph"] = 0;
      new_item["lastSaved"] = dateFormat(timestamp);
      new_item["caseName"] = name;
      // cause there is no o_id before get response,use a fake o_id to replace it temporarily
      new_item["o_id"] = "p10";
      // create new case in advance(have not sent request yet)
      commit("createCase", new_item);
      let case_index = findCaseByName(state.allCases, name);
      let case_id;
      // send request
      try {
        let res = await dispatch("update", {
          case_title: name,
          action: "createCase"
        });
        if (res.data.code == 200) {
          console.log("store", res.data);
          // replace the fake oid by response data
          let case_oid = `c${res.data["vc_id"]}`;
          state.allCases[case_index]["o_id"] = case_oid;
        } else {
          ifError = true;
        }
      } catch (error) {
        ifError = true;
      }
      // set the requestPending to false
      commit("pendingToggle");
      if (ifError) {
        // delete the case if the operation failed
        commit("caseDelete", case_index);
        return Promise.reject();
      } else {
        return Promise.resolve(case_id);
      }
    },
    /**
     * move item to case
     * @param {Object} _data -{target_case:target case's oid}
     */
    async moveItem({ dispatch, commit, state }, _data) {
      // set pending to true
      commit("pendingToggle");

      let beSelected = state.beSelected;
      //items that were not in the target case
      let couldMoveArr = [];
      // determine to return resolve or reject
      let ifError = false;
      // backup
      let backupCase = deepClone(state.allCases);
      let backupItem = deepClone(state.allItems);


      while (beSelected.length > 0) {
        let cur_item = beSelected.pop();
        let item = state.allItems[indexQuery(state.allItems, cur_item)];
        let pre_case_index, pre_case;
        //pass if the item is belong to the target case
        if (item["case_belong_id"]) {
          pre_case_index = indexQuery(state.allCases, item["case_belong_id"]);
          pre_case = state.allCases[pre_case_index];
          if (pre_case["o_id"] == _data["target_case"]) {
            continue;
          }
        }
        // push available item to array
        couldMoveArr.push(cur_item);

        _data["item_oid"] = cur_item;
        _data["pre_case_index"] = pre_case_index;
        console.log("moveItem:", _data);
        commit("moveItem", _data);
      }
      // send request
      while (couldMoveArr.length > 0) {
        let curItem = couldMoveArr.pop();
        let vc_id = _data["target_case"].slice(1);
        let vf_id = curItem.slice(1);
        try {
          let res = await dispatch("update", {
            action: "repositionFile",
            vc_id: vc_id,
            vf_id: vf_id
          });
          if (res.data.code !== 200) {
            ifError = true;
          }
        } catch (e) {
          console.log(e);
          ifError = true;
        }
      }
      // set pending to false
      commit("pendingToggle");
      if (ifError) {
        commit("getCases", backupCase);
        commit("getItems", backupItem);
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
    /**
     * move item to new case
     * @param {Object} _data -{name:case's name,timestamp:timestamp}
     */
    async moveItemToNewCase({ dispatch, commit, state }, _data) {
      // set pending to true
      commit("pendingToggle");

      let beSelected = state.beSelected;
      let new_item = {},
        ifError = false,
        pre_case_index,
        item,
        case_create_succuss = false;
      let backupCase = deepClone(state.allCases);
      let backupItem = deepClone(state.allItems);

      // create case
      new_item["doc"] = 0;
      new_item["graph"] = 0;
      new_item["lastSaved"] = dateFormat(_data["timestamp"]);
      new_item["caseName"] = _data["name"];
      new_item["o_id"] = "p10";
      commit("createCase", new_item);
      let moveArr = [];
      // move item to case
      while (beSelected.length > 0) {
        let cur_item = beSelected.pop();
        moveArr.push(cur_item);
        item = state.allItems[indexQuery(state.allItems, cur_item)];
        pre_case_index = indexQuery(state.allCases, item["case_belong_id"]);
        _data["item_oid"] = cur_item;
        _data["pre_case_index"] = pre_case_index;
        _data["target_case"] = "p10";
        console.log("moveItem:", _data);
        commit("moveItem", _data);
      }
      // request
      let vc_id, vf_id;
      try {
        let res = await dispatch("update", {
          case_title: _data["name"],
          action: "createCase"
        });
        if (res.data.code !== 200) {
          ifError = true;
        } else {
          case_create_succuss = true;
          vc_id = res.data.vc_id;
        }
      } catch (e) {
        ifError = true;
      }
      if (!ifError) {
        for (let i in moveArr) {
          let curItem = moveArr[i];
          vf_id = curItem.slice(1);
          console.log(vf_id, vc_id);
          try {
            let moveRes = await dispatch("update", {
              action: "repositionFile",
              vc_id: vc_id,
              vf_id: vf_id
            });
            if (moveRes.data.code !== 200) {
              ifError = true;
              break;
            }
          } catch (e) {
            ifError = true;
            break;
          }
        }
      }
      // set pending to false
      commit("pendingToggle");
      if (ifError) {
        commit("getCases", backupCase);
        commit("getItems", backupItem);
        // recreate the case if the case has created succesfully
        if (case_create_succuss) {
          new_item["graph"] = 0;
          new_item["doc"] = 0;
          new_item["o_id"] = `c${vc_id}`;
          commit("createCase", new_item);
        }
        return Promise.reject();
      } else {
        // change both case and item's oid if the operation success
        state.allCases[0]["o_id"] = `c${vc_id}`;
        for (let i in moveArr) {
          let move_item =
            state.allItems[indexQuery(state.allItems, moveArr[i])];
          move_item["case_belong_id"] = `c${vc_id}`;
        }
        return Promise.resolve();
      }
    },
    /**
     * move out
     */
    async itemMoveOut({ dispatch, commit, state }) {
      // set pending to true
      commit("pendingToggle");

      let beSelected = state.beSelected;
      let type, itemIndex, case_oid;
      let data = {};
      let ifError = false;

      // update view
      for (let i in beSelected) {
        let item_oid = beSelected[i];
        itemIndex = indexQuery(state.allItems, item_oid);
        type = state.allItems[itemIndex]["type"];
        case_oid = state.allItems[itemIndex]["case_belong_id"];
        data["item_oid"] = item_oid;
        data["case_oid"] = case_oid;
        data["type"] = type;
        commit("itemMoveOut", data);
      }
      //send request
      while (beSelected.length > 0) {
        let curItem = beSelected.pop();
        try {
          let res = await dispatch("update", {
            action: "repositionFile",
            vc_id: "",
            vf_id: curItem.slice(1)
          });
          if (res.data.code !== 200) {
            ifError = true;
          }
        } catch (e) {
          ifError = true;
        }
      }
      // set pending to false
      commit("pendingToggle");
      if (ifError) {
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
    /**
     * delete
     */
    async delete({ state, commit, dispatch }) {
      // set pending to true
      commit("pendingToggle");

      let beSelected = state.beSelected;
      let type, id, action, index, queryArr, commitFunc;
      let ifError = false;
      // backup
      let backupCase = deepClone(state.allCases);
      let backupItem = deepClone(state.allItems);
      let backupTag = deepClone(state.tags);

      // update view
      for (let i in beSelected) {
        let curItem = beSelected[i];
        type = curItem.slice(0, 1) == "c" ? "vc_id" : "vf_id";
        queryArr = type == "vc_id" ? state.allCases : state.allItems;
        commitFunc = type == "vc_id" ? "caseDelete" : "deleteItem";
        index = indexQuery(queryArr, curItem);
        commit(commitFunc, index);
      }
      // request
      while (beSelected.length > 0) {
        let cur_item = beSelected.pop();
        type = cur_item.slice(0, 1) == "c" ? "vc_id" : "vf_id";
        action = cur_item.slice(0, 1) == "c" ? "del_case" : "del_file";
        id = cur_item.slice(1);
        let payload = {};
        payload[type] = id;
        payload["action"] = action;
        try {
          let res = await dispatch("update", payload);
          if (res.data.code !== 200) {
            ifError = true;
          }
        } catch (err) {
          ifError = true;
          console.log(err);
        }
      }

      if (ifError) {
        commit("pendingToggle");
        commit("getCases", backupCase);
        commit("getItems", backupItem);
        commit("getTags", backupTag);
        return Promise.reject();
      } else {
        // refresh if operation success
        await dispatch("getWorkSpace");
        commit("pendingToggle");
        return Promise.resolve();
      }
    }
  },
  getters: {
    selectNum: state => {
      return state.beSelected.length;
    },
    tagNowSelect: state => {
      return state.tagBeSelected.filter(v => {
        return state.tags.includes(v);
      });
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js